<template>
  <div class="kye_public_area_select_address_box" ref="addressBox">
    <div class="box_title">
      <div class="title_left">地区选择</div>
      <div class="title_right">
        <div class="select_title">
          已选择
          <div class="select_num">(已选 <span class="select_total">{{this.checkedData.length}}</span> 项)</div>
        </div>
        <div class="delete_all" v-if="!readOnly" @click.stop="clearAll"><i class="iconfont layout-delete" /> 清空</div>
      </div>
    </div>
    <div class="box_menu">
      <div class="menu_left">
        <div class="address_search">
          <kye-autocomplete
            ref="search"
            class="search_input"
            v-model="searchValue"
            :disabled="readOnly"
            :highlight-first-item="true"
            :trigger-on-focus="false"
            :popper-append-to-body="false"
            :fetch-suggestions="searchAddress"
            placeholder="请输入区域/行政区号"
            @select="(item) => handleSearch(item)"
            @keyup.native.enter="handleEnter"
          >
          <span slot-scope="scope" v-html="scope.item.$value"></span>
        </kye-autocomplete>
        </div>
        <div class="hot_area" v-if="hotList.length > 0">
          <span>热门地区:</span>
          <kye-checkbox v-for="(item, index) in hotList" :key="index" :disabled="readOnly" :label="item.districtID" v-model="item.isChecked" @change="(type) => checkedHot(type, item)">{{getHotCitySimpleName(item.simpleName)}}</kye-checkbox>
        </div>
        <div class="menu_content">
          <div :class="[`area_list area_list_${zoomIndex}`, {'is_hidden_checkbox': !showCheckBoxMaps[zoomIndex]}]"  v-if="zoomIndex < level" v-for="(zoomItem, zoomIndex) in zoomList" :key="zoomIndex">
            <div>
              <div :class="['area_list_title', { select_color: isSelectColor(zoomIndex) }]">{{zoomItem.name}}</div>
              <div class="area_list_content">
                <el-scrollbar wrap-style="overflow-x:hidden;">
                  <div :class="['list_item',`list_item_${vIndex}`,{'is_choose':v.isChoose}, {'hidden_list_item': zoomIndex === 0 && vIndex === 0 && !showCountry}]" v-for="(v,vIndex) in selectData[zoomIndex]" :key="vIndex">
                    <kye-checkbox  :indeterminate="v.isIndeterminate" :disabled="readOnly" v-model="v.isChecked" @change="(type) => specialChecked(type,v,vIndex,zoomIndex)">
                    </kye-checkbox>
                    <div class="item_choose" @click="showChildren(v, vIndex, zoomIndex)">
                      <div :class="['address_name', {'address_name_indeterminate':v.isIndeterminate}]" :title="v.districtName">{{v.simpleName||v.districtName}}</div>
                        <i class="el-icon-arrow-right item_arrow" v-if="vIndex!==0 && zoomIndex+1<level && !v.noChildrent" ></i>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu_right">
        <el-scrollbar>
          <div class="menu_right_tag">
            <kye-tag
              v-for="(v, index) of checkedData"
              :key="v.id"
              class="tag_item"
              :closable="!readOnly"
              @close="deleteName(v,index)"
            >
              {{ v.simpleName || v.districtName }}
            </kye-tag>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="box_button">
      <el-button @click.stop="saveArea" type="primary">确定</el-button>
      <el-button @click.stop="cancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import { REGION_TREE, ZOOM_LIST } from './common'
 import cloneDeep from 'lodash/cloneDeep'
 import isNumber from 'lodash/isNumber'
import { getAreaLinkData, getAreaChildren, searchFetch, setPeer, setFather, clearChildren, clearStatus, openAddressLink, batchSearchFetch } from './utils'
export default {
  name: 'area-picker',
  props: {
    // 弹出框的显示隐藏
    showMenu: {
      type: Boolean
    },
    // 下拉搜索前的事件fetch
    beforeSearch: {
      type: Function
    },
    // 最多可选择
    maxlength: {
      type: Number,
    },
    // 地址树数据
    areaData: {
      type: Array
    },
    // 热门城市列表
    hotList: {
      type: Array
    },
    // 默认显示几级
    level: {
      type: Number,
      default: 5
    },
    // 只读状态
    readOnly: {
      type: Boolean
    },
    // 添加区域前的事件fetch
    beforeAdd: {
      type: Function
    },
    // 组件确认按钮点击前的事件
    beforeSumbit: {
      type: Function
    },
    // 过程搜索结果
    filterSearchData: {
      type: Function
    },
    // 批量粘贴链接符
    batchPateSeparator: {
      type: String,
      default: '/'
    },
    isSelectAll: {
      type: Boolean,
      default: true
    },
    showCheckBoxMaps: {
      type: Object,
      default: () => {}
    },
    showCountry: {
      type: Boolean,
    }
  },
  watch: {
    showMenu: {
      immediate: true,
      handler (val) {
        if (val) {
          this.showHistoryDataChecked(cloneDeep(this.areaData))
          this.$nextTick(() => {
            this.$refs.search.focus()
          })
        } else {
          this.clearAll()
        }
      }
    }
  },
  data() {
    return {
      zoomList: cloneDeep(ZOOM_LIST),
      areaTree: cloneDeep(REGION_TREE),
      searchValue: '',
      historyData: [],
      checkedData: [],
      checkedListData: [],
      selectData: [[], [], [], [], []],
      idMap: null,
      lastCheckedData: [],
    }
  },
  mounted() {
    this.getAreaData()
  },
  methods: {
    // 下拉搜索
    async searchAddress(val, cb) {
      try {
        if (this.beforeSearch && typeof this.beforeSearch === 'function') {
          this.beforeSearch(val, cb)
          return
        }
        let resultData = await searchFetch.bind(this)(val)
        if (resultData !== null) {
          if (this.filterSearchData && typeof this.filterSearchData === 'function') {
            resultData = this.filterSearchData(resultData)
          }
          cb(resultData)
        }
      } catch (error) {
        console.error('[kye-area-select]:searchAddress', error)
      }
    },
    getHotCitySimpleName(name) {
      return name.split('市')[0]
    },
    getAreaData() {
      const areaList = this.areaTree.childrenNode
      const childrenData = [
        this.areaTree,
        ...areaList
      ]
      this.idMap = new Map()
      this.idMap.set(this.areaTree.districtID, this.areaTree)
      this.$set(this.selectData, [0], childrenData)
      areaList.forEach((item) => {
        item._parent = this.areaTree
        this.idMap.set(item.districtID, item)
      })
    },
    isMaxLength(isSave = false) {
      if (this.maxlength) {
        const result = isSave ? this.checkedData.length > this.maxlength : this.checkedData.length >= this.maxlength
        if (result) {
          this.$message.warning(`最多选择${this.maxlength}个地区`)
          return true
        }
        return false
      }
      return false
    },
    // 回写数据到连级菜单中
    async showHistoryDataChecked(val) {
      let idArry = []
      const isCurrent = val.some(item => this.idMap && !this.idMap.has(item.districtID))
      if (isCurrent) {
        idArry = val.map(item => item.districtID)
      } else {
        idArry = []
      }
      await getAreaLinkData(idArry, this.idMap, this.areaTree, this.isSelectAll)
      val && val.forEach((item, itemIndex) => {
        const checkedItem = this.idMap.get(item.districtID)
        if (checkedItem) {
          this.changeCheckBox(true, checkedItem, 1)
          if (itemIndex === val.length - 1) {
            openAddressLink(checkedItem, this.selectData)
          }
        } else {
          // 不存在的情况需要获取上级链路数据
          this.checkedData.push(item)
        }
      })
    },
    // 递归打开最后一个城市
    async showChildren(v, index, key) {
      if (v.noChildrent) {
        return
      }
      if (key >= this.level - 1) {
        return
      }
      if (index === 0 && key === 0) {
        for (let i = key + 1; i < this.level; i++) {
          this.selectData[i] = []
        }
        return false
      }
      v._parent && v._parent.childrenNode.forEach((k) => {
        k.isChoose = false
      })
      let data
      v.isChoose = true
      if (v.childrenNode && v.childrenNode.length) {
        data = v.childrenNode
      } else {
        data = await getAreaChildren(this.idMap, v, key + 1, this.isSelectAll)
      }
      const childrenData = index === 0 ? [] : data
      for (let i = key + 1; i < this.level; i++) {
        this.selectData[i] = []
      }
      this.$set(this.selectData, [key + 1], childrenData)
    },
    async handleEnter() {
      const areaSearchInstance = this.$refs.search && this.$refs.search.suggestions
      if (!areaSearchInstance.length && this.searchValue) {
        const data = await batchSearchFetch(this.searchValue, this.batchPateSeparator)
        if (data && data.length) {
          const oldCheckDataLength = this.checkedData.length
          const newData = data.map(item => item.districtList[0])
          if (newData && newData.length) {
            newData.forEach(item => {
                const selectItem = {
                  simpleName: item.districtName,
                  districtName: item.districAllName,
                  districtLevel: item.districtLevel,
                  id: item.districtID,
                }
                this.handleSearch(selectItem, false)
            })
            this.$nextTick(() => {
              if (oldCheckDataLength === this.checkedData.length) {
                this.$message.error(`请不要重复添加城市哦，谢谢配合~`)
              }
            })
          } else {
            this.$message.error(`添加城市有误，请检查后重新添加`)
          }
        }
      }
    },
    // 下拉搜索选中
    handleSearch(item, isMessage = true) {
      const searchItem = {
        simpleName: (item.value && item.value.split('(')[0]) || item.simpleName,
        districtName: item.districtName,
        districtLevel: item.districtLevel,
        districtID: item.id,
        districtAllId: item.districtAllId,
        districtAllName: item.districtAllName,
        zoneCode: item.zoneCode,
        _isSearch: true,
      }
      this.searchValue = ''
      this.checkoutBeforeAdd(searchItem)
      this.cancelCheckedAll()
      const repeatItem = this.getRepeat(searchItem)
      if (repeatItem) {
        isMessage && this.$message.error(`已添加过${repeatItem.simpleName || repeatItem.districtName}`)
        return
      }
      const isMax = this.isMaxLength()
      if (isMax) {
        return false
      }
      this.checkedData.push(searchItem)
    },
    // tag删除操作
    deleteName(item, index) {
      if (item.isHistory) {
        this.checkedData.splice(this.checkedData.findIndex(v => {
          return v.districtID === item.districtID
        }), 1)
        return
      }
      if (item._isHot) {
        // 热门地区移除
        this.hotList.find(v => {
          if (v.districtID === item.districtID) {
            v.isChecked = false
          }
        })
        this.checkedHot(false, item)
      } else if (item._isSearch) {
        // 搜索地区移除
        this.checkedData.splice(this.checkedData.findIndex(v => {
          return v.districtID === item.districtID
        }), 1)
      } else {
        // 选择联动地区移除
        const indexKey = this.selectData[item._erpZoom].indexOf(item)
        item.isChecked = false
        this.changeCheckBox(false, item, indexKey, item._erpZoom)
      }
    },
    // 删除所有操作
    clearAll() {
      this.checkedListData = []
      this.historyData = []
      this.checkedData = []
      this.selectData = [[], [], [], [], []]
      this.hotList.forEach(item => {
        item.isChecked = false
      })
      const areaList = this.areaTree.childrenNode
      const childrenData = [
        this.areaTree,
        ...areaList
      ]
      this.$set(this.selectData, [0], childrenData)
      clearStatus(this.areaTree)
    },
    // 连级特殊处理
    specialSet(item, itemIndex, type) {
      if (item.districtID !== 'all') {
        this.areaTree.isChecked = false
      }
      if (itemIndex === 0) {
        if (item._parent) {
          item._parent.isChecked = true
          item._parent.isIndeterminate = false
        }
      } else {
        if (item.childrenNode && !this.isSelectAll) {
          item.childrenNode[0] && (item.childrenNode[0].isChecked = type)
        }
      }
    },
    specialChecked(type, item, itemIndex, key) {
      if (this.isSelectAll) {
        if (item.noChildrent) {
          // 全选勾选
          // item.isChecked = !type
          item._parent.childrenNode.forEach((i, index) => {
            if (i.districtID) {
              if (type) {
                // 全选
                if (!i.isChecked) {
                  i.isChecked = true
                  this.changeCheckBox(true, i, index, key)
                }
              } else {
                if (i.isChecked) {
                  i.isChecked = false
                  this.changeCheckBox(false, i, index, key)
                }
              }
            }
          })
        } else {
          this.changeCheckBox(type, item, itemIndex, key)
        }
      } else {
        this.changeCheckBox(type, item, itemIndex, key)
      }
    },
    // 连级勾选handler
    async changeCheckBox(type, item, itemIndex, key) {
      try {
        if (type) {
          // 检测重复数据return和检测超出最大限制
          if (item.districtID !== 'all') {
            const isMax = this.isMaxLength()
            if (isMax) {
              item.isChecked = false
              return false
            }
          }
          this.checkoutBeforeAdd(item, true)
          const repeatItem = this.getRepeat(item, true)
          if (repeatItem) {
            item.isChecked = false
            this.$message.error(`已添加过${repeatItem.simpleName || repeatItem.districtName}`)
            return
          }
        }
        // step1 递归清除当前节点子集中的所有选中数据
        clearChildren(item)
        // step2 展示下级(同步获取接口数据)
        type && isNumber(key) && await this.showChildren(item, itemIndex, key)
        // step3 同级展示操作
        setPeer(item, itemIndex, type, this.isSelectAll)
        // step4 特殊情况处理
        this.specialSet(item, itemIndex, type)
        // step5 递归设置上层节点展示状态
        setFather(item, this.isSelectAll)

        this.isSelectAll && this.setAllChecked(item)

        this.lastCheckedData = cloneDeep(this.checkedListData)
        this.checkedListData = []

        // step6 获取tree数据中被选中的数据
        this.getChecked(this.areaTree)

        // step7 push或者delete数据
        this.getAddOrDeleteItems(type)
      } catch (err) {
        console.error('[kye-area-select]:changeCheckBox', err)
      }
    },
    setAllChecked(item) {
      let isAllChecked = true
      item._parent && item._parent.childrenNode.forEach(v => {
        if (v.districtID) {
          if (!v.isChecked) {
            isAllChecked = false
          }
        }
      })
      const checkedItem = item._parent && item._parent.childrenNode.find(i => i.noChildrent)
      checkedItem && (checkedItem.isChecked = isAllChecked)
    },
    // 对比上次的数据判断新增或删除的数据
    getAddOrDeleteItems(type) {
        this.checkedListData.forEach((item) => {
          const sameItem = this.lastCheckedData.find(key => {
            return key.districtID === item.districtID
          })
          if (!sameItem) {
            this.checkedData.push(item)
          }
        })
        this.lastCheckedData.forEach(item => {
          const sameItem = this.checkedListData.find(key => {
            return key.districtID === item.districtID
          })
          if (!sameItem) {
            const index = this.checkedData.findIndex(v => {
              return v.districtID === item.districtID
            })
            if (index >= 0) {
              this.checkedData.splice(index, 1)
            }
          }
        })
    },
    // 获取连级数据中被选中的值
    getChecked(item) {
      // 选中全国
      if (item.districtID === 'all' && item.isChecked) {
        this.clearAll()
        item.isChecked = true
        this.checkedListData.push(item)
        return
      }
      item.childrenNode && item.childrenNode.forEach((v, vIndex) => {
        if (v.isChecked || v.isChoose || v.isIndeterminate) {
          if (v._erpZoom === 0) {
            if (v.isChecked && !v.noChildrent) {
              if (v.childrenNode && v.childrenNode.length) {
                const isAllChecked = v.childrenNode && v.childrenNode[0].isChecked
                if (this.isSelectAll) {
                  !isAllChecked && this.checkedListData.push(v)
                } else {
                  isAllChecked && this.checkedListData.push(v)
                }
              } else {
                this.checkedListData.push(v)
              }
            }
            this.getChecked(v)
          } else {
            if (vIndex !== 0) {
              if (v.isChecked && !v.noChildrent) {
                if (v.childrenNode && v.childrenNode.length) {
                  const isAllChecked = v.childrenNode[0].isChecked
                  if (this.isSelectAll) {
                    !isAllChecked && this.checkedListData.push(v)
                  } else {
                    isAllChecked && this.checkedListData.push(v)
                  }
                } else {
                  this.checkedListData.push(v)
                }
              }
              this.getChecked(v)
            }
          }
        }
      })
    },
    // 获取重复item
    getRepeat(item) {
      return this.checkedData.find((v) => {
        return v.districtID === item.districtID
      })
    },
    // 取消联级菜单的全国勾选
    cancelCheckedAll() {
      if (this.areaTree.isChecked) {
          // 全国被选中去掉勾选，去除勾选数据
          this.areaTree.isChecked = false
          this.checkedData = []
        }
    },
    // 获取热门地区选中 checkedHot
    async checkedHot(type, item) {
      this.cancelCheckedAll()
      this.checkoutBeforeAdd(item, true)
      if (type) {
        const isMax = this.isMaxLength()
        if (isMax) {
          item.isChecked = false
          return false
        }
        const repeatItem = this.getRepeat(item)
        if (repeatItem) {
          this.$message.error(`已添加过${repeatItem.simpleName || repeatItem.districtName}`)
          item.isChecked = false
          return
        }
        this.checkedData.push({
          ...item,
          _isHot: true
        })
      } else {
        this.checkedData.splice(this.checkedData.findIndex(v => {
          return v.districtID === item.districtID
        }), 1)
      }
    },
    checkoutBeforeAdd(item, cancelChecked) {
      if (this.beforeAdd) {
        const checkedData = cloneDeep(this.checkedData)
        const result = this.beforeAdd(item, checkedData, cancelChecked)
        if (result) {
          cancelChecked && (item.isChecked = false)
          throw new Error('checkoutBeforeAdd break')
        }
      }
    },
    saveArea() {
      // 保存操作
      if (!this.showMenu) return
      const data = cloneDeep(this.checkedData)
      data.forEach(item => {
        item.isHistory = true
      })
      const isMax = this.isMaxLength(true)
      if (isMax) {
        return false
      }
      if (this.beforeSumbit && typeof this.beforeSumbit === 'function') {
        const result = this.beforeSumbit(data)
        if (result) return
      }
      this.$emit('change', data)
      this.$emit('showMenu', false)
    },
    cancel() {
      this.$emit('showMenu', false)
    },
    isSelectColor (index) {
      const lastIndex = this.selectData.findLastIndex(item => item.length > 0)
      return index === lastIndex
    }
  }
}
</script>
<style lang="scss" scoped>
  .kye_public_area_select_address_box {
    user-select:none;
    display: flex;
    flex-direction: column;
    .box_title {
      height: 40px;
      line-height: 40px;
      display: flex;
      font-size: 16px;
      border-bottom: 1px solid var(--g-border-color);
      color: var(--g-color-text);
      align-content: center;
      .title_left {
        flex: 1;
        padding-left: 16px;
        font-weight: 600;
      }
      .title_right {
        width: 258px;
        display: flex;
        padding: 0 16px;
        justify-content: space-between;
        border-left: 1px solid var(--g-border-color);
        .select_title {
          display: flex;
          flex-direction: row;
          font-weight: 600;
          .select_num {
            color: #999999;
            font-size: 14px;
            font-weight: 500;
            .select_total {
              color: var(--g-color-primary);
            }
          }
        }
        .delete_all {
          color: var(--g-color-primary);
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    .box_menu {
      flex: 1;
      display: flex;
      .menu_left {
        // flex: 1;
        padding: 12px 12px 12px 16px;
        .address_search {
          .search_input {
            width: 220px;
            margin-right: 8px;
          }
        }
        .hot_area {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-size: 14px;
          margin-top: 12px;
          color: var(--g-color-text);
          .hot_check {
            margin-left: 12px;
          }
          > span {
            margin-right: 8px;
            font-size: 13px;
            font-weight: 600;
          }
        }
        .menu_content {
          display: flex;
          border-radius: 2px;
          font-size: 12px;
          margin-top: 12px;
          .area_list {
            display: flex;
            width: 130px;
            background:  var(--g-bg-primary);
            flex-direction: column;
            border-left: 1px solid var(--g-border-color);
            &:first-child {
              border-left: none;
            }
            .area_list_title {
              padding-left: 12px;
              border-bottom: 1px solid var(--g-border-color);
              color: var(--g-color-text);
              font-weight: 700;
              line-height: 32px;
            }
            .select_color {
              color: var(--g-color-primary);
              border-color: var(--g-color-primary);
            }
            .area_list_content {
              height: 236px;
              .list_item{
                flex: 1;
                display: flex;
                // overflow-y: scroll;
                cursor: pointer;
                align-items: center;
                padding: 2px 12px;
                box-sizing: border-box;
                &:hover {
                  background: #F1F1F5;
                }
                .item_arrow{
                  height: 28px;
                  line-height: 28px;
                  flex: 1;
                  text-align: right
                }
                .el-checkbox{
                  display: flex;
                  align-items: center;
                }
                .address_name {
                  width: 74px;
                  line-height: 28px;
                  color: var(--g-color-text);
                  // display: inline-flex;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .address_name_indeterminate {
                  color: var(--g-color-primary);
                }
                .item_choose {
                  display: flex;
                  justify-content: space-between;
                  margin-left: 8px;
                }
              }
              .hidden_list_item {
                display: none;
              }
              .is_choose {
                background: #F2F3F7;
                .address_name {
                  color: var(--g-color-primary);
                }
                &:hover {
                  .address_name {
                    color: var(--g-color-primary);
                  }
                }
              }
              .el-scrollbar {
                height: 100%;
              }
              .el-scrollbar__wrap {
                height: 100%;
                overflow-y: scroll;
                overflow-x: hidden;
              }
              .el-scrollbar__bar.is-horizontal {
                display: none;
              }
            }
          }
          .is_hidden_checkbox {
            .list_item {
              .el-checkbox {
                display: none !important;
              }
            }
          }
        }
      }
      .menu_right {
        width: 258px;
        max-height: 367px;
        border-left: 1px solid var(--g-border-color);
        .el-scrollbar {
          max-height: 100%;
        }
        .el-scrollbar__wrap {
          height: 100%;
          overflow-y: scroll;
          overflow-x: hidden;
        }
        .el-scrollbar__bar.is-horizontal {
          display: none;
        }
        .menu_right_tag {
          max-height: 367px;
        }
        .tag_item {
          height: 28px;
          margin-left: 8px;
          margin-top: 8px;
          padding: 0 6px;
          background: #f3f3fd;
          color: var(--g-color-text);
          line-height: 28px;
        }
        /deep/ .el-tag .el-icon-close {
          font-size: 16px;
          height: 18px;
          width: 18px;
          line-height: 18px;
          color: #8e8e8e !important;
        }
        /deep/ .el-tag .el-icon-close:hover {
          color: #ffffff !important;
          background-color: #a3a3a3;
        }
      }
    }
    .box_button {
      padding: 12px 15px;
      border-top: 1px solid var(--g-border-color);
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-area-select/area-picker.vue